import React, { useState, useEffect } from 'react';
import './assets/StaticUser.css';

//import bg from './assets/bg1.svg';
import bg1 from './assets/farm.webp';
//import star from './assets/bg1.svg';
import phone from './assets/phone.png';
import { Circle } from 'rc-progress';
import { emitter, E_GET_STATS } from '../../event';
/*
cef_stats("{\"show\": true, \"progress\": {\"sati\":50, \"hp\": 100, \"level\":1, \"exp\":1,\"maxexp\": 8,\"zakon\":50}, 
\"name\": \"Player Name\", \"age\": 18, \"indicators\": [ 10, 20, 30, 40 ,50 ,60], \"phone\": {\"number\": 1111, \"balance\": 123}, \"wanted\": 4 }")
*/
export const Static = () => {
   // ----- хуки -----
   type StatsInterface = {
      show: boolean;

      progress: {
         power: number;
         hp: number;
         level: number;
         exp: number;
         maxexp: number;
         zakon: number;
      };

      name: string;
      sex: number;
      cash: number;
      bank: string;
      credits: number;
      indicators: Array<number>;

      phone: {
         number: number;
         balance: number;
      };

      wedding: string;

      family: {
          name: string;
          owner: string;
          cash: number;
          score: number;
      };

      cartUser: {
         home: string;
         home2: string;
         busi: string;
         fraction: string;
         job: string;
         land: string;
         rank: string;
         subdiv: string;
         rankNum: number;
      };
   };

   const [state, setState] = useState({
      show: false,

      progress: {
         power: 0,
         hp: 100,
         level: 1,
         exp: 1,
         maxexp: 8,
         zakon: 50,
      },

      name: 'Player Name',
      sex: 0,
      cash: 0,
      bank: '0',
      credits: 0,
      indicators: [66, 10, 10, 20, 30, 40],

      phone: {
         number: 1234,
         balance: 999,
      },

      wedding: '-',

      family: {
          name: '-',
          owner: '-',
          cash: 0,
          score: 0
      },

      cartUser: {
         home: '',
         home2: '',
         busi: '',
         fraction: '',
         job: '',
         land: '',
         rank: '',
         subdiv: '',
         rankNum: 0,
      },
   });

   const IndicatorsName = ['наркотики', 'патроны', 'металл', 'маски', 'аптечки', 'BattlePass'];

   const escKey = (e: any) => {
      if (state.show !== true) return;
      if (e.keyCode === 27) return closeStats();
      return;
   };

   const closeStats = () => {
      setState({ ...state, show: false });
      window.cef.set_focus(false);
      window.cef.emit('cef:statsResponse', 0);
   };

   const openSkill = () => {
      setState({ ...state, show: false });
      window.cef.set_focus(false);
      window.cef.emit('cef:statsResponse', 1);
      //      window.cef.emit('cef:openSkills');
   };

   useEffect(() => {
      document.addEventListener('keydown', escKey);
      const unsubscribe = emitter.subscribe(E_GET_STATS, (data: any) => {
         let result: StatsInterface = JSON.parse(data, function (key, value) {
            return value;
         });
         //         console.log(data);
         setState({ ...state, ...result });
         window.cef.set_focus(true);
         return;
      });
      return () => {
         console.log('off');
         document.removeEventListener('keydown', escKey);
         unsubscribe();
      };
      //},[]);
   });

   const strokeWidth = 6; // что-то очень неожиданное
   const trailWidth = 6; // что-то очень неожиданное
   const trailColor = 'rgba(255, 255, 255,0.2)'; // что-то очень неожиданное

   if (state.show !== true) return null;

   return (
      <div className="Static">
         <div className="Static_img"></div>
         <div className="Static_Container">
            <div className="Static_ober">
               {/* LEFT SIDE */}
               <div className="Container_Box3-ober Container_Box3-ober--left">
                  <div className="Container-box3-bag">
                     <div className="box2-line" style={{marginBottom: '1vh', justifyContent: 'center'}}>
                         <span className="Box2-name" style={{fontSize: '2vh', fontWeight: 'bold'}}>Семья</span>
                     </div>
                     
                     <ul>
                        <li className="box3-bag-li">
                           Название
                           <div className="box3-bag-text" style={{color: '#ffffffff'}}>
                               {state.family.name}
                           </div>
                        </li>
                        <li className="box3-bag-li">
                           Основатель
                           <div className="box3-bag-text" style={{color: '#ffffffff'}}>
                               {state.family.owner}
                           </div>
                        </li>
                        <li className="box3-bag-li">
                           Касса
                           <div className="box3-bag-text" style={{color: '#00cc66'}}>
                               ${state.family.cash.toLocaleString()}
                           </div>
                        </li>
                        <li className="box3-bag-li">
                           Очки
                           <div className="box3-bag-text" style={{color: '#3791f9ff'}}>
                               {state.family.score}
                           </div>
                        </li>
                     </ul>
                  </div>

                 {/* --- ЗЕМЕЛЬНЫЙ УЧАСТОК --- */}
                  <div className="Container-box2-tel" style={{
                           background: `url(${bg1}) no-repeat center center`,
                           backgroundSize: 'cover'
                       }}>
                     <div className="Container-street" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        
                        <div className="Container-street-tel-line" style={{ width: '100%', justifyContent: 'center', marginBottom: '0.5vh' }}>
                           <div className="street-text-tel" style={{ textAlign: 'center' }}>Земельный участок:</div>
                        </div>

                        <p className="box3-bag-text" style={{fontSize: '1.8vh', textAlign: 'center', lineHeight: '1.2', margin: 0}}>
                           {state.cartUser.land && state.cartUser.land !== '' ? (
                              state.cartUser.land.includes('(') ? (
                                 <>
                                  {/* Номер */}
                                    {state.cartUser.land.split('(')[0].trim()}
                                    <br />
                                    {/* Район */}
                                    <span style={{ fontSize: '1.4vh', opacity: 0.8 }}>
                                       {state.cartUser.land.split('(')[1].replace(')', '').trim()}
                                    </span>
                                 </>
                              ) : (
                                 state.cartUser.land
                              )
                           ) : (
                              'Нет'
                           )}
                        </p>
                        
                     </div>
                  </div>
                  {/* -------------------------------------------------- */}
               </div> 

               {/* CENTER */}
               <div className="Static_Container-box2">
                  <div className="Container-box2-aboutMe">
                     <div className="Container-box2-column">
                        <div>
                           <div className="box2-line">
                              <span className="Box2-name">имя фамилия:</span>
                              <div className="Box2-name1">{state.name}</div>
                           </div>

                           <div className="Box2-age">пол:</div>
                           <div className="Box2-age1">{state.sex === 0 ? 'мужской' : 'женский'}</div>

                           {/* MARRIAGE BLOCK */}
                           <div className="Box2-age">{state.sex === 0 ? 'женат на:' : 'замужем за:'}</div>
                           <div className="Box2-name1" style={{ fontSize: '1.2vh' }}>
                              {state.wedding}
                           </div>
                        </div>

                        <div className="Box-circlee">
                           {/* 1. LEVEL */}
                           <div className="oberee">
                              <div className="ee">
                                 <span className="aa">
                                    <p>{state.progress.level}</p>
                                    <div className="lvl">
                                       {state.progress.exp}/{state.progress.maxexp}
                                    </div>
                                 </span>
                                 <Circle
                                    className="me-test"
                                    style={{
                                       filter: 'drop-shadow(0px 0px 15px rgba(250, 207, 55, 1))',
                                       borderRadius: '50px',
                                    }}
                                    percent={(state.progress.exp / state.progress.maxexp) * 100.0}
                                    strokeWidth={strokeWidth}
                                    strokeLinecap="square"
                                    strokeColor="#facf37"
                                    trailWidth={trailWidth}
                                    trailColor={trailColor}
                                 />
                              </div>
                              <div>
                                 <p className="gg">уровень</p>
                              </div>
                           </div>

                           {/* 2. ZAKON */}
                           <div className="oberee">
                              <div className="ee">
                                 <span className="aa-one">
                                    <p>{state.progress.zakon}</p>
                                 </span>
                                 <Circle
                                    className="me-test"
                                    style={{
                                       filter: 'drop-shadow(0px 0px 15px rgba(55, 145, 250, 1))',
                                       borderRadius: '50px',
                                    }}
                                    percent={state.progress.zakon}
                                    strokeWidth={strokeWidth}
                                    strokeLinecap="square"
                                    strokeColor="#3791fa"
                                    trailWidth={trailWidth}
                                    trailColor={trailColor}
                                 />
                              </div>
                              <div>
                                 <p className="gg ">законопослушность</p>
                              </div>
                           </div>

                           {/* 3. HEALTH */}
                           <div className="oberee">
                              <div className="ee">
                                 <span className="aa-one">
                                    <p>{state.progress.hp}</p>
                                 </span>
                                 <Circle
                                    className="me-test"
                                    style={{
                                       filter: 'drop-shadow(0px 0px 15px rgba(122, 202, 115, 1))',
                                       borderRadius: '50px',
                                    }}
                                    percent={state.progress.hp}
                                    strokeWidth={strokeWidth}
                                    strokeLinecap="square"
                                    strokeColor="#7aca73"
                                    trailWidth={trailWidth}
                                    trailColor={trailColor}
                                 />
                              </div>
                              <div>
                                 <p className="gg ">здоровье</p>
                              </div>
                           </div>

                           {/* 4. POWER */}
                           <div className="oberee">
                              <div className="ee">
                                 <span className="aa-one">
                                    <p>{state.progress.power}</p>
                                 </span>
                                 <Circle
                                    className="me-test"
                                    style={{
                                       filter: 'drop-shadow(0px 0px 15px rgba(224, 75, 75, 1))',
                                       borderRadius: '50px',
                                    }}
                                    percent={state.progress.power}
                                    strokeWidth={strokeWidth}
                                    strokeLinecap="square"
                                    strokeColor="#e04b4b"
                                    trailWidth={trailWidth}
                                    trailColor={trailColor}
                                 />
                              </div>
                              <div>
                                 <p className="gg ">Сила</p>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>

                  <div className="Container_Cart-ober">
                     <div>
                        {/* === CASH CARD === */}
                        <div className="Container-box2-cash">
                           <div className="Container-box-svg">
                              <p className="box2-home">Финансы</p>
                              <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path
                                    d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z"
                                    fill="white"
                                 />
                                 <path
                                    d="M12 17C13.6569 17 15 15.6569 15 14C15 12.3431 13.6569 11 12 11C10.3431 11 9 12.3431 9 14C9 15.6569 10.3431 17 12 17Z"
                                    fill="white"
                                 />
                              </svg>
                           </div>
                           <div className="Container-street">
                              <div className="street-text">Наличные: ${state.cash.toLocaleString()}</div>
                              <div className="street-text">Банковский счет: ${state.bank.toLocaleString()}</div>
                          <div className="street-text">Advance Credits: {state.credits.toLocaleString()}</div>
                           </div>
                        </div>
                        {/* === END CASH CARD === */}

                        <div className="Container-box2-home">
                           <div className="Container-box-svg">
                              <p className="box2-home">Проживание</p>
                              <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path
                                    d="M12.5 0.875L25 12.125H21.25V22.125H15V14.625H10V22.125H3.75V12.125H0L12.5 0.875Z"
                                    fill="white"
                                 />
                              </svg>
                           </div>
                           <div className="Container-street">
                              {/* Первый дом */}
                              <div className="street-text">
                                  {state.cartUser.home !== '' ? state.cartUser.home : 'у вас нет дома'} 
                              </div>
                              
                              {/* Второй дом (отображается только если есть) */}
                              {state.cartUser.home2 && state.cartUser.home2 !== '' && (
                                  <div className="street-text" style={{ 
                                      marginTop: '0.2vh' 
                                  }}>
                                      {state.cartUser.home2}
                                  </div>
                              )}
                           </div>
                        </div>

                        <div className="Container-box2-biz">
                           <div className="Container-box-svg">
                              <p className="box2-home">бизнес</p>
                              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <g clipPath="url(#clip0)">
                                    <path
                                       d="M15.625 6.771C15.05 6.771 14.5834 6.30433 14.5834 5.72933V4.16683H10.4167V5.72933C10.4167 6.30433 9.95001 6.771 9.37501 6.771C8.80001 6.771 8.33334 6.30433 8.33334 5.72933V4.16683C8.33334 3.01787 9.26772 2.0835 10.4167 2.0835H14.5834C15.7323 2.0835 16.6667 3.01787 16.6667 4.16683V5.72933C16.6667 6.30433 16.2 6.771 15.625 6.771Z"
                                       fill="white"
                                    />
                                    <path
                                       d="M13.2396 16.0207C13.0521 16.0936 12.7812 16.1457 12.5 16.1457C12.2187 16.1457 11.9479 16.0936 11.6979 15.9998L0 12.104V20.0519C0 21.6352 1.28125 22.9165 2.86458 22.9165H22.1354C23.7187 22.9165 25 21.6352 25 20.0519V12.104L13.2396 16.0207Z"
                                       fill="white"
                                    />
                                    <path
                                       d="M25 8.07308V10.4585L12.75 14.5418C12.6667 14.5731 12.5833 14.5835 12.5 14.5835C12.4167 14.5835 12.3333 14.5731 12.25 14.5418L0 10.4585V8.07308C0 6.48975 1.28125 5.2085 2.86458 5.2085H22.1354C23.7187 5.2085 25 6.48975 25 8.07308Z"
                                       fill="white"
                                    />
                                 </g>
                                 <defs>
                                    <clipPath id="clip0">
                                       <rect width="25" height="25" fill="white" />
                                    </clipPath>
                                 </defs>
                              </svg>
                           </div>
                           <div className="Container-street">
                              <div className="street-text">
                                 {state.cartUser.busi !== '' ? state.cartUser.busi : 'у вас отсутствует \nбизнес'}
                              </div>
                           </div>
                        </div>
                     </div>

                     <div>
                        <div className="Container-box2-frac">
                           <div className="Container-box-svg">
                              <p className="box2-home">фракция</p>
                              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <g clipPath="url(#clip0)">
                                    <path
                                       d="M15.3809 8.83789C15.3809 9.64546 14.7236 10.3027 13.916 10.3027C13.5548 10.3027 13.208 10.1704 12.9396 9.93004C12.723 9.73778 12.414 9.69124 12.1523 9.80701C11.8883 9.92508 11.7188 10.1868 11.7188 10.4757V13.3333C11.4719 13.2668 11.216 13.2324 10.9556 13.2324C9.33972 13.2324 8.02594 14.5464 8.02594 16.1621C8.02594 17.7778 9.33972 19.0918 10.9556 19.0918C11.2173 19.0918 11.4712 19.0454 11.7188 18.9785V25H6.56109C6.15617 25 5.81055 24.6723 5.81055 24.2676V20.5566H3.63141C3.22648 20.5566 2.88087 20.229 2.88087 19.8242V16.1621H0.683604C0.440417 16.1621 0.213634 16.0412 0.0770674 15.8401C-0.0587358 15.6393 -0.0867739 15.3831 0.00344372 15.1579L1.95046 10.3363V8.10547C1.95046 3.66306 5.5647 0 10.0071 0H11.7188V7.19986C11.7188 7.48882 11.8883 7.7507 12.1523 7.86877C12.4155 7.98531 12.723 7.93877 12.9396 7.74574C13.208 7.50542 13.5548 7.37305 13.916 7.37305C14.7236 7.37305 15.3809 8.03032 15.3809 8.83789Z"
                                       fill="white"
                                    />
                                    <path
                                       d="M24.2187 16.1621H21.9726V19.8242C21.9726 20.229 21.6452 20.5566 21.2402 20.5566H19.043V24.2676C19.043 24.6723 18.7155 25 18.3105 25H13.1836V17.7721C13.1836 17.1654 12.417 16.8039 11.9526 17.2358C11.6808 17.4883 11.3268 17.627 10.9556 17.627C10.148 17.627 9.49077 16.9697 9.49077 16.1621C9.49077 15.3547 10.148 14.6973 10.9556 14.6973C11.3268 14.6973 11.6808 14.8361 11.9526 15.0887C12.1658 15.2866 12.4769 15.3397 12.7437 15.2237C13.0112 15.1072 13.1836 14.8432 13.1836 14.5521V11.6747C13.421 11.7361 13.6663 11.7676 13.916 11.7676C15.5317 11.7676 16.8457 10.4538 16.8457 8.83789C16.8457 7.22218 15.5317 5.9082 13.916 5.9082C13.6663 5.9082 13.421 5.93967 13.1836 6.00128V0H14.8645C19.3069 0 22.9212 3.66306 22.9212 8.10547V10.3363L24.8989 15.1579C24.9891 15.3831 24.9613 15.6393 24.8253 15.8403C24.6887 16.0412 24.4619 16.1621 24.2187 16.1621Z"
                                       fill="white"
                                    />
                                 </g>
                                 <defs>
                                    <clipPath id="clip0">
                                       <rect width="25" height="25" fill="white" />
                                    </clipPath>
                                 </defs>
                              </svg>
                           </div>

                           <div className="Container-street">
                              <div
                                 className="street-text"
                                 style={{
                                    fontSize: state.cartUser.fraction.length > 15 ? '1.3vh' : undefined,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    maxWidth: '490px',
                                 }}
                              >
                                 {state.cartUser.fraction !== '' ? state.cartUser.fraction : 'вы не состоите \nво фракции'}
                              </div>

                              {state.cartUser.rank !== '' ? (
                                 <span className="street-text">
                                    {state.cartUser.rank} ({state.cartUser.rankNum})
                                 </span>
                              ) : null}

                              {state.cartUser.subdiv !== '' ? (
                                 <span className="street-text" style={{ fontSize: '1.2vh', color: '#ccc', marginTop: '2px' }}>
                                    {state.cartUser.subdiv}
                                 </span>
                              ) : null}
                           </div>
                        </div>

                        {/* JOB */}
                        <div className="Container-box2-job">
                           <div className="Container-box-svg">
                              <p className="box2-home">работа</p>
                              <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <path
                                    d="M20 6H16V4C16 2.89 15.11 2 14 2H10C8.89 2 8 2.89 8 4V6H4C2.89 6 2 6.89 2 8V19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V8C22 6.89 21.11 6 20 6ZM10 4H14V6H10V4ZM20 19H4V8H20V19ZM12 11C13.66 11 15 12.34 15 14C15 15.66 13.66 17 12 17C10.34 17 9 15.66 9 14C9 12.34 10.34 11 12 11Z"
                                    fill="white"
                                 />
                              </svg>
                           </div>
                           <div className="Container-street">
                              <div className="street-text">{state.cartUser.job && state.cartUser.job !== '' ? state.cartUser.job : 'вы безработный'}</div>
                           </div>
                        </div>

                        <div className="Container-box2-nav">
                           <div className="Container-nav">
                              <div className="Container-nav-lin">
                                 <div className="street-text-nav">ваши навыки</div>
                                 <span className="nav-text">и способности</span>
                              </div>
                              <button className="box2-nav-btn" onClick={openSkill}>
                                 показать
                              </button>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

               {/* RIGHT SIDE (existing) */}
               <div className="Container_Box3-ober">
                  <div className="Container-box3-bag">
                     <ul>
                        {state.indicators.map((arr, id) => {
                           return (
                              <li className="box3-bag-li" key={id}>
                                 {IndicatorsName[id]}
                                 <div className="box3-bag-text">{arr}</div>
                              </li>
                           );
                        })}
                     </ul>
                  </div>

                  <div className="Container-box2-tel">
                     <div className="Container-street">
                        <div className="Container-street-tel-line">
                           <div className="street-text-tel">ваш номер:</div>
                           <span className="street-number">{state.phone.number}</span>
                        </div>
                        <div className="street-number-value">
                           <p className="street-number-value-tel">${state.phone.balance}</p>
                        </div>
                     </div>
                     <span className="Container_Box3-img-phone">
                        <img className="imgtel" src={phone} alt="" />
                     </span>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};